import { z } from 'zod';

import { dashboardT } from '../../../lib/messages';

export const assetTagsFormSchema = z.object({
  tags: z.array(z.string().trim().min(1)),
});

export const assetUploadFormSchema = assetTagsFormSchema.extend({
  files: z.array(z.instanceof(File)).min(1, dashboardT('a2v.assets.upload.filesRequired')),
});

export type AssetTagsFormValue = z.infer<typeof assetTagsFormSchema>;
export type AssetUploadFormValue = z.infer<typeof assetUploadFormSchema>;
